import { contentKeys } from 'features/content/api/queryKeys'

export const nodesKeys = {
  nodes: () => [...contentKeys.all, 'nodes'] as const,
}
